import type { ReactNode } from 'react'
import { SearchXIcon } from 'lucide-react'
import { useLingui } from '@lingui/react/macro'

export function PanelEmptyState(props: {
  noResults?: boolean
  icon: ReactNode
  title: string
  description?: string
  action?: ReactNode
}) {
  const { t } = useLingui()

  if (props.noResults) {
    return (
      <div className="flex flex-col items-center gap-3 px-4 py-12 text-center">
        <div className="bg-muted/50 rounded-full p-3">
          <SearchXIcon className="text-muted-foreground size-5" />
        </div>
        <div className="flex flex-col gap-1">
          <p className="text-muted-foreground text-sm font-medium">{t`No results found`}</p>
          <p className="text-muted-foreground text-xs">{t`Try a different search term`}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center gap-3 px-4 py-12 text-center">
      <div className="bg-muted/50 rounded-full p-3">{props.icon}</div>
      <div className="flex flex-col gap-1">
        <p className="text-md font-medium">{props.title}</p>
        {props.description && <p className="text-muted-foreground text-sm whitespace-pre-wrap">{props.description}</p>}
      </div>
      {props.action && <div className="pt-2">{props.action}</div>}
    </div>
  )
}
